import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { DeliveryService } from 'src/app/services/delivery.service';
import { FlowersSaleService } from 'src/app/services/flowers-sale.service';
import { DeluxyFlowersSaleFormDialogComponent } from '../deluxy-flowers-sale-form-dialog/deluxy-flowers-sale-form-dialog.component';

@Component({
  selector: 'app-deluxy-flowers-sale',
  templateUrl: './deluxy-flowers-sale.component.html',
  styleUrls: ['./deluxy-flowers-sale.component.scss']
})
export class DeluxyFlowersSaleComponent implements OnInit {

  limit: number;
  page: number;
  count: number;
  maxPage: number;
  filtered: {};
  orders: string[];
  deluxyFlowersSaleForm: any;
  order: {};
  myjson:any=JSON;
  groups: any;
  selected: string = 'active';
  settings = {
    active: {
      title: "Flowers Vendite",
    },
    inactive: {
      title: "Storico Flowers Vendite",
    }
  };
  defaultPage = 1;
  defaultLimit = 100;
  defaultOrder = { 'FlowersSales.actualOrderId': 'DESC' };
  btnDisable: boolean = false;
  
  constructor(
    private authStatusService: AuthStatusService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router,
    private deliveryService: DeliveryService,
    private flowersSaleService: FlowersSaleService,
  ) { 
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    this.manageFlowersSalesFilterForm();
  }

  async ngOnInit(){
    this.selected = !this.route.snapshot.data['active'] ? 'inactive' : 'active';
    await this.filter();
  }

  async manageFlowersSalesFilterForm(){
    this.deluxyFlowersSaleForm = new FormGroup({
      'FlowersSales.orderId': new FormControl(''),
      'FlowersSales.actualOrderId': new FormControl(''),
      'FlowersSales.firstName': new FormControl(''), 
      'FlowersSales.deliveryDate_from': new FormControl(''), 
      'FlowersSales.deliveryDate_to': new FormControl(''),   
      'FlowersSales.lastName': new FormControl(''),  
      'FlowersSales.channel': new FormControl(''),
      'FlowersSales.total': new FormControl(''),
      'FlowersSales.paymentStatus': new FormControl(''),
      'FlowersSales.fullFillmentStatus': new FormControl(''),
      'FlowersSales.deliveryMethod': new FormControl(''),
      'FlowersSales.address': new FormControl(''),
      'FlowersSales.pickUpTime': new FormControl(''),
      'FlowersSales.phone': new FormControl(''),
      'FlowersSales.deliveryDate': new FormControl(''),
      'FlowersSales.vendor': new FormControl(''),
      'FlowersSales.status': new FormControl(''),
    });
  }

  async filter() {

    let filterForm = (new FormGroupToObject()).transform(this.deluxyFlowersSaleForm);
    this.filtered = {};
    if (filterForm['FlowersSales.orderId'])
      this.filtered['FlowersSales.orderId'] = filterForm['FlowersSales.orderId'];    
    if (filterForm['FlowersSales.actualOrderId'])
      this.filtered['FlowersSales.actualOrderId'] = filterForm['FlowersSales.actualOrderId'];    
    if (filterForm['FlowersSales.firstName'])
      this.filtered['FlowersSales.firstName'] = { operator: 'like', values: [`%${filterForm['FlowersSales.firstName']}%`] };
    if (filterForm['FlowersSales.channel'])
      this.filtered['FlowersSales.channel'] = { operator: 'like', values: [`%${filterForm['FlowersSales.channel']}%`] };
    if (filterForm['FlowersSales.total'])
      this.filtered['FlowersSales.total'] = { operator: 'like', values: [`%${filterForm['FlowersSales.total']}%`] };
    if (filterForm['FlowersSales.paymentStatus'])
      this.filtered['FlowersSales.paymentStatus'] = { operator: 'like', values: [`%${filterForm['FlowersSales.paymentStatus']}%`] };
    if (filterForm['FlowersSales.fullFillmentStatus'])
      this.filtered['FlowersSales.fullFillmentStatus'] = { operator: 'like', values: [`%${filterForm['FlowersSales.fullFillmentStatus']}%`] };
    if (filterForm['FlowersSales.deliveryMethod'])
      this.filtered['FlowersSales.deliveryMethod'] = { operator: 'like', values: [`%${filterForm['FlowersSales.deliveryMethod']}%`] };
    if (filterForm['FlowersSales.address'])
      this.filtered['FlowersSales.address'] = { operator: 'like', values: [`%${filterForm['FlowersSales.address']}%`] };
    if (filterForm['FlowersSales.pickUpTime'])
      this.filtered['FlowersSales.pickUpTime'] = { operator: 'like', values: [`%${filterForm['FlowersSales.pickUpTime']}%`] };
    if (filterForm['FlowersSales.phone'])
      this.filtered['FlowersSales.phone'] = { operator: 'like', values: [`%${filterForm['FlowersSales.phone']}%`] };
    if (filterForm['FlowersSales.deliveryDate_from'])
      this.filtered['FlowersSales.deliveryDate'] = { operator: 'moreThanOrEqual', values: [filterForm['FlowersSales.deliveryDate_from']] };
    if (filterForm['FlowersSales.deliveryDate_to'])
      this.filtered['FlowersSales.deliveryDate'] = { operator: 'lessThan', values: [filterForm['FlowersSales.deliveryDate_to']] };
    if (filterForm['FlowersSales.deliveryDate_from'] && filterForm['FlowersSales.deliveryDate_to'])
      this.filtered['FlowersSales.deliveryDate'] = { operator: 'between', values: [filterForm['FlowersSales.deliveryDate_from'], filterForm['FlowersSales.deliveryDate_to']] };
    if (filterForm['FlowersSales.vendor'])
      this.filtered['FlowersSales.vendor'] = { operator: 'like', values: [`%${filterForm['FlowersSales.vendor']}%`] };
    if (filterForm['FlowersSales.status'])
      this.filtered['FlowersSales.status'] = { operator: 'like', values: [`%${filterForm['FlowersSales.status']}%`] };

    await this.getFlowersSalesOrders();
  }

  async getFlowersSalesOrders(limit?: number, page?: number, order?: {}){

    this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
    this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
    this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;
    let promiseResult = null;
    promiseResult = this.selected == 'active' ? 
      this.flowersSaleService.getFlowersSaleOrders(this.page, this.limit, this.order, this.filtered) :
      this.flowersSaleService.getFlowersSaleOrdersHistory(this.page, this.limit, this.order, this.filtered);
    promiseResult.then((res) => {
      this.orders = res.orders;
      this.count = res.count;
      this.maxPage = Math.ceil(this.count / this.limit);
    }).catch((err) => {
      console.log("err", err)
    })
  }

  async confirmSale(saleOrder: any) {
    if(this.groups.includes('admin') || this.groups.includes('operation') || this.groups.includes('teamleader')){
      /*If Sale if unique then not confirm sale because partner is still accept or reject the sale*/
      let delivery = await this.deliveryService.getDeliveryWithOrderId(saleOrder?.orderId, saleOrder?.realOrderNumber);
      if(delivery){
        this._snackBar.open(`This is unique product sale. Delivery has been created. Partner is still accpet or reject the sale`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        });
        return false;
      }
      /*If Sale if unique then not confirm sale because partner is still accept or reject the sale*/
      let ref = this.dialog.open(DeluxyFlowersSaleFormDialogComponent, { width: '80vw', data: { saleOrder } });
      ref.afterClosed().subscribe(async (result) => {
        if (result?.delivery){
          await this.getFlowersSalesOrders();
        }
      });
    } else {
      return false;
    }
  }

  async refuseSale(orderId: number){
    if(!confirm(`Sei sicuro di voler rifiutare l'ordine di Shopify?`))
      return false;
    let promiseResult = await this.flowersSaleService.refuseSaleByAdmin(orderId);
    if(promiseResult.success){
      this._snackBar.open(`L'ordine di Shopify è stato rifiutato. Puoi controllare nella cronologia`, 'Chiudi', {
        direction: "ltr",
        duration: 2000,
        horizontalPosition: "center",
        politeness: "assertive",
        verticalPosition: "top"
      });
      await this.getFlowersSalesOrders();
    } else {
      this._snackBar.open(`Qualcosa è andato storto`, 'Chiudi', {
        direction: "ltr",
        duration: 2000,
        horizontalPosition: "center",
        politeness: "assertive",
        verticalPosition: "top"
      });
    }
  }

  async stopSaleAutomation(sale: any){
    if(!confirm(`Are You Sure to Stop Sale Automation ${sale?.platform?.toLowerCase()}?`))
      return false;
    try {
      this.btnDisable = true;
      let id: number = sale?.id;
      let promiseResult = await this.flowersSaleService.stopSaleAutomation(id, sale);

      if(promiseResult.success){
        this._snackBar.open(`Sale Automation has been Stopped.`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        });
      } else {
        this._snackBar.open(`Something Went Wrong`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        });
      }
      await this.getFlowersSalesOrders();
    } catch (error) {
      this.btnDisable = false;
      this._snackBar.open(`Something Went Wrong ${error?.error?.message}`, 'Chiudi', {
        direction: "ltr",
        duration: 2000,
        horizontalPosition: "center",
        politeness: "assertive",
        verticalPosition: "top"
      });
    }
  }


  async resetFilter() {
    await this.manageFlowersSalesFilterForm();
    await this.filter();
  }

  async navigate(event) {
    await this.getFlowersSalesOrders(event.limit, event.page, this.order);
  }

  public async navigateOrder(attribute: string | string[]) {
    delete this.order['FlowersSales.updatedAt'];
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          this.order[attr] = 'DESC';
          break;
        case 'DESC':
          this.order[attr] = undefined;
          break;
        default:
          this.order = {}
          this.order[attr] = 'ASC';
          break;
      }
    }

    await this.navigatePage(this.limit, this.page, { order: this.order });
  }

  async navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(async (data) => {
      await this.getFlowersSalesOrders();
    });
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          // Keep the same
          break;
        case '[object Array]':
        case '[object Object]':
          // Convert to JSON
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          // Not supported type
          delete args[key];
          break;
      }
    });
    return args;
  }

  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          return 'fa-sort-up';
        case 'DESC':
          return 'fa-sort-down';
        default:
          return 'fa-sort';
      }
    }
  }

}
